import axios from './axios';

export default class AuthService {
  static signIn(payload) {
    return axios.post(window.entityCabinetSettings.openApi.url + '/api/msi/individual/auth', payload);
  }

  static getRecoveryPasswordOtp(login) {
    return axios.post(window.entityCabinetSettings.openApi.url + '/api/msi/individual/recovery/start', {
      login,
      purpose: 'password-change'
    });
  }

  static recoveryPassword(payload) {
    return axios.post(window.entityCabinetSettings.openApi.url + '/api/msi/individual/recovery/finish', payload);
  }

  static getOtpCode(phone_number, purpose) {
    return axios.post(window.entityCabinetSettings.openApi.url + '/api/notification/sms/otp', {
      phone_number,
      ...(purpose ? { purpose } : {})
    });
  }

  static getAuthorizedOtpCode() {
    return axios.get(window.entityCabinetSettings.openApi.url + '/api/notification/sms/otp', {
      params: {
        purpose: 'password-change'
      }
    });
  }

  static changeEmail(email) {
    return axios.post(window.entityCabinetSettings.openApi.url + '/api/notification/mail/confirm/send', { email });
  }

  static confirmEmail(payload) {
    return axios.post(window.entityCabinetSettings.openApi.url + '/api/notification/mail/confirm', payload);
  }

  static getProfile() {
    return axios.get(window.entityCabinetSettings.openApi.url + '/api/msi/individual/profile');
  }

  static getActualMsiInfoRedirectUrl() {
    return axios.get(window.entityCabinetSettings.openApi.url + '/api/msi/individual/actual-info/redirect-url');
  }

  static getActualMsiInfo(payload) {
    return axios.post(window.entityCabinetSettings.openApi.url + '/api/msi/individual/actual-info', payload);
  }

  static approveActualMsiInfo(payload) {
    return axios.post(window.entityCabinetSettings.openApi.url + '/api/msi/individual/actual-info/decision', payload);
  }

  static declineActualMsiInfo(payload) {
    return axios.post(window.entityCabinetSettings.openApi.url + '/api/msi/individual/actual-info/decision', payload);
  }

  static changeLivingAddress(payload) {
    return axios.post(window.entityCabinetSettings.openApi.url + '/api/msi/individual/living-address', payload);
  }

  static confirmCardFounds() {
    return axios.post(window.entityCabinetSettings.openApi.url + '/api/offer/confirm-card-funded');
  }

  static editLenderWorkInfo(workInfo) {
    const formData = new FormData();

    formData.append('work_info', JSON.stringify(workInfo));

    return axios.post(
      window.entityCabinetSettings.openApi.url + '/api/msi/individual/extra-info',
      formData
    );
  }

  static editBorrowerWorkInfo(workInfo, extraUserInfo, files = {}) {
    const formData = new FormData();

    formData.append('work_info', JSON.stringify(workInfo));
    formData.append('extra_user_info', JSON.stringify(extraUserInfo));

    (files.car_passport_files || []).forEach((item) => {
      formData.append('car_passport_files', item.file);
    });

    (files.real_estate_files || []).forEach((item) => {
      formData.append('real_estate_files', item.file);
    });

    return axios.post(
      window.entityCabinetSettings.openApi.url + '/api/msi/individual/extra-info',
      formData
    );
  }

  static refreshToken() {
    const token = localStorage.getItem('token');

    return fetch(window.entityCabinetSettings.openApi.url + '/api/session/refresh-token', {
      method: 'get',
      headers: new Headers({
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      })
    });
  }
}